import { __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { officialEmotes } from '../official-emotes';
var OfficialEmoteViewer = /** @class */ (function (_super) {
    __extends(OfficialEmoteViewer, _super);
    function OfficialEmoteViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OfficialEmoteViewer.prototype.render = function () {
        var componentData = this.props.componentData;
        var emoteCode = componentData.emote.trim();
        if (!officialEmotes[emoteCode]) {
            return null;
        }
        var emote = officialEmotes[emoteCode];
        return (React.createElement("img", { src: "https://e.deviantart.net/emoticons" + emote.src, alt: emote.name, width: emote.width, height: emote.height }));
    };
    OfficialEmoteViewer.propTypes = {
        componentData: PropTypes.object.isRequired,
        theme: PropTypes.object,
    };
    return OfficialEmoteViewer;
}(React.Component));
var CommunityEmoteViewer = /** @class */ (function (_super) {
    __extends(CommunityEmoteViewer, _super);
    function CommunityEmoteViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommunityEmoteViewer.prototype.render = function () {
        var componentData = this.props.componentData;
        if (!componentData.src) {
            return null;
        }
        if (componentData.url) {
            return (React.createElement("a", { href: componentData.url, title: componentData.title },
                React.createElement("img", { src: componentData.src, alt: componentData.title, width: componentData.width, height: componentData.height })));
        }
        return (React.createElement("img", { src: componentData.src, alt: componentData.title, width: componentData.width, height: componentData.height }));
    };
    CommunityEmoteViewer.propTypes = {
        componentData: PropTypes.object.isRequired,
        theme: PropTypes.object,
    };
    return CommunityEmoteViewer;
}(React.Component));
export { OfficialEmoteViewer, CommunityEmoteViewer };
//# sourceMappingURL=ReactViewer.js.map